import { useQuery } from "@tanstack/react-query";
import { skillKeys } from "@/lib/query";
import type { SkillListItem } from "@/lib/skills/types";

export function useMySkills() {
  return useQuery({
    queryKey: skillKeys.mine,
    queryFn: async (): Promise<SkillListItem[]> => {
      const res = await fetch("/api/my-skills");
      if (!res.ok) throw new Error("Failed to fetch your skills");
      const json: { data: SkillListItem[] } = await res.json();
      return json.data;
    },
  });
}
